import success from "../../../assets/success.png";

function Success() {
  return (
    <div className="h-[calc(100vh-165px)] sm:h-full flex flex-col items-center justify-center px-4">
      <div className="max-w-[400px] flex flex-col items-center justify-center">
        <img
          src={success}
          className="w-[75px] mb-4 text-center"
          alt="success"
        />
        <p className="text-[#1F2328] text-xl text-center font-bold mb-4">
          Success! Your Authorization Letter request has been sent
        </p>
        <p className="text-[#60656D] text-center mb-4">
          Great news! Your request for an Authorization Letter has been
          successfully sent. We'll process it promptly and notify you once it's
          ready. Thank you for choosing our service!
        </p>
        <p className="text-red-600 text-center">
          3 DAYS LOA VALIDITY UPON APPROVAL
        </p>
      </div>
    </div>
  );
}

export default Success;
